(function() {
    'use strict';
  
    class DeliveryTimeline {
      constructor(element) {
        this.element = element;
        this.blockId = element.dataset.blockId;
        
        this.usOrderDays = parseInt(element.dataset.usOrderDays) || 3;
        this.usShippingDays = parseInt(element.dataset.usShippingDays) || 7;
        this.intlOrderDays = parseInt(element.dataset.intlOrderDays) || 3;
        this.intlShippingDays = parseInt(element.dataset.intlShippingDays) || 14;
        this.dateFormat = element.dataset.dateFormat || 'MMMM d';
        
      this.countrySelector = element.querySelector('.deliver-to-country');
      this.countryFlag = element.querySelector('.shipping-country-flag');
      this.countryName = element.querySelector('[data-country-name]');
      this.dateTimeNew = element.querySelector('.date-time-new');
      this.modal = element.querySelector('.modal-shipping');
      this.modalContent = element.querySelector('.box-hover-shipping');
      this.closeBtn = element.querySelector('.icon-closed-fulfillment');
      
      this.countryModal = document.getElementById(`delivery-country-modal-${this.blockId}`);
      this.countryModalSelect = this.countryModal?.querySelector('[data-country-select]');
      this.countryModalSave = this.countryModal?.querySelector('.delivery-country-modal-save');
      this.countryModalClose = this.countryModal?.querySelector('.delivery-country-modal-close');
      this.countryModalOverlay = this.countryModal?.querySelector('.delivery-country-modal-overlay');
        
        this.orderPlacedDate = element.querySelector('[data-timeline-date="order-placed"]');
        this.orderShipsDate = element.querySelector('[data-timeline-date="order-ships"]');
        this.deliveredDate = element.querySelector('[data-timeline-date="delivered"]');
        
        this.currentCountry = this.detectCountry();
        this.init();
      }
  
      detectCountry() {
        const saved = localStorage.getItem(`delivery_timeline_country_${this.blockId}`);
        if (saved) return saved;
        
        const defaultCountry = this.element.dataset.defaultCountry;
        if (defaultCountry) return defaultCountry;
        
        return 'US';
      }
  
    init() {
      this.updateCountry(this.currentCountry);

      if (this.countrySelector) {
        this.countrySelector.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.showCountryModal();
        });
      }

      if (this.dateTimeNew && this.modalContent) {
        let hoverTimeout = null;
        let isHoveringDate = false;
        let isHoveringModal = false;
        
        this.dateTimeNew.addEventListener('mouseenter', () => {
          isHoveringDate = true;
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = null;
          }
          this.modalContent.classList.add('show');
        });

        this.dateTimeNew.addEventListener('mouseleave', () => {
          isHoveringDate = false;
          hoverTimeout = setTimeout(() => {
            if (!isHoveringModal) {
              this.modalContent.classList.remove('show');
            }
          }, 150);
        });

        this.modalContent.addEventListener('mouseenter', () => {
          isHoveringModal = true;
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = null;
          }
          this.modalContent.classList.add('show');
        });

        this.modalContent.addEventListener('mouseleave', () => {
          isHoveringModal = false;
          hoverTimeout = setTimeout(() => {
            if (!isHoveringDate) {
              this.modalContent.classList.remove('show');
            }
          }, 150);
        });

        this.dateTimeNew.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleModal();
        });
      }

      if (this.countryModalClose) {
        this.countryModalClose.addEventListener('click', () => {
          this.hideCountryModal();
        });
      }

      if (this.countryModalOverlay) {
        this.countryModalOverlay.addEventListener('click', () => {
          this.hideCountryModal();
        });
      }

      if (this.countryModalSave) {
        this.countryModalSave.addEventListener('click', () => {
          const selectedCountry = this.countryModalSelect?.value;
          if (selectedCountry) {
            this.updateCountry(selectedCountry);
            localStorage.setItem(`delivery_timeline_country_${this.blockId}`, selectedCountry);
            this.hideCountryModal();
          }
        });
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.hideModal();
        });
      }

      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.hideModal();
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.isCountryModalVisible()) {
            this.hideCountryModal();
          } else if (this.isModalVisible()) {
            this.hideModal();
          }
        }
      });
    }

    showCountryModal() {
      if (this.countryModal) {
        if (this.countryModal.parentElement !== document.body) {
          document.body.appendChild(this.countryModal);
        }
        
        this.countryModal.setAttribute('aria-hidden', 'false');
        this.countryModal.style.cssText = 'display: flex !important; position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100vw !important; height: 100vh !important; z-index: 999999 !important; align-items: center !important; justify-content: center !important; margin: 0 !important; padding: 0 !important;';
        document.body.style.overflow = 'hidden';
      }
    }

    hideCountryModal() {
      if (this.countryModal) {
        this.countryModal.setAttribute('aria-hidden', 'true');
        this.countryModal.style.cssText = 'display: none !important;';
        document.body.style.overflow = '';
      }
    }

    isCountryModalVisible() {
      return this.countryModal && this.countryModal.getAttribute('aria-hidden') === 'false';
    }
  
    toggleModal() {
      if (this.isModalVisible()) {
        this.hideModal();
      } else {
        this.showModal();
      }
    }

    showModal() {
      if (this.modalContent) {
        this.modalContent.classList.add('show');
        this.modalContent.style.display = 'flex';
        this.modalContent.style.visibility = 'visible';
        this.modalContent.style.opacity = '1';
        document.body.style.overflow = 'hidden';
      }
    }

    hideModal() {
      if (this.modalContent) {
        this.modalContent.classList.remove('show');
        this.modalContent.style.display = '';
        this.modalContent.style.visibility = '';
        this.modalContent.style.opacity = '';
        document.body.style.overflow = '';
      }
    }

    isModalVisible() {
      return this.modalContent && this.modalContent.classList.contains('show');
    }
  
      updateCountry(countryCode) {
        this.currentCountry = countryCode.toUpperCase();
        const isUS = this.currentCountry === 'US';

        // Bridge config + country to the cart page (read by cart-template delivery script)
        try {
          localStorage.setItem('minimog_delivery_config', JSON.stringify({
            usOrderDays: this.usOrderDays,
            usShippingDays: this.usShippingDays,
            intlOrderDays: this.intlOrderDays,
            intlShippingDays: this.intlShippingDays
          }));
          localStorage.setItem('minimog_delivery_country', this.currentCountry);
        } catch (e) {}
        
        const countryName = this.getCountryName(this.currentCountry);
        if (this.countryName) {
          this.countryName.textContent = countryName;
        }
        
        if (this.countryFlag) {
          const flagUrl = `//cdn.shopify.com/static/images/flags/${this.currentCountry.toLowerCase()}.svg?width=20`;
          this.countryFlag.src = flagUrl;
          this.countryFlag.setAttribute('data-country-code', this.currentCountry);
        }
  
        const orderDays = isUS ? this.usOrderDays : this.intlOrderDays;
        const shippingDays = isUS ? this.usShippingDays : this.intlShippingDays;
        
        const today = new Date();
        
        const orderPlacedDate = new Date(today);
        
        const orderShipsStartDate = new Date(today);
        orderShipsStartDate.setDate(today.getDate() + orderDays);
        const orderShipsEndDate = new Date(today);
        orderShipsEndDate.setDate(today.getDate() + orderDays + 2);
        
        const deliveredStartDate = new Date(today);
        deliveredStartDate.setDate(today.getDate() + orderDays + shippingDays - 2);
        const deliveredEndDate = new Date(today);
        deliveredEndDate.setDate(today.getDate() + orderDays + shippingDays + 2);
  
        const formatDate = (date) => {
          return this.formatDate(date, 'MMMM d');
        };

        if (this.orderPlacedDate) {
          this.orderPlacedDate.textContent = formatDate(orderPlacedDate);
        }

        if (this.orderShipsDate) {
          if (orderDays === orderDays + 2) {
            this.orderShipsDate.textContent = formatDate(orderShipsStartDate);
          } else {
            const startMonth = this.formatDate(orderShipsStartDate, 'MMMM');
            const startDay = this.formatDate(orderShipsStartDate, 'd');
            const endMonth = this.formatDate(orderShipsEndDate, 'MMMM');
            const endDay = this.formatDate(orderShipsEndDate, 'd');
            
            if (startMonth === endMonth) {
              this.orderShipsDate.textContent = `${startMonth} ${startDay}-${endDay}`;
            } else {
              this.orderShipsDate.textContent = `${startMonth} ${startDay}-${endMonth} ${endDay}`;
            }
          }
        }

        if (this.deliveredDate) {
          const startMonth = this.formatDate(deliveredStartDate, 'MMMM');
          const startDay = this.formatDate(deliveredStartDate, 'd');
          const endMonth = this.formatDate(deliveredEndDate, 'MMMM');
          const endDay = this.formatDate(deliveredEndDate, 'd');
          
          if (startMonth === endMonth) {
            this.deliveredDate.textContent = `${startMonth} ${startDay}-${endDay}`;
          } else {
            this.deliveredDate.textContent = `${startMonth} ${startDay}-${endMonth} ${endDay}`;
          }
        }
  
        if (this.dateTimeNew) {
          const startMonth = this.formatDate(deliveredStartDate, 'MMMM');
          const startDay = this.formatDate(deliveredStartDate, 'd');
          const endMonth = this.formatDate(deliveredEndDate, 'MMMM');
          const endDay = this.formatDate(deliveredEndDate, 'd');
          
          if (startMonth === endMonth) {
            this.dateTimeNew.textContent = `${startMonth} ${startDay}-${endDay}`;
          } else {
            this.dateTimeNew.textContent = `${startMonth} ${startDay}-${endMonth} ${endDay}`;
          }
        }
      }
  
      getCountryName(code) {
        const countries = {
          'US': 'United States',
          'CA': 'Canada',
          'GB': 'United Kingdom',
          'AU': 'Australia',
          'DE': 'Germany',
          'FR': 'France',
          'IT': 'Italy',
          'ES': 'Spain',
          'NL': 'Netherlands',
          'BE': 'Belgium',
          'AT': 'Austria',
          'CH': 'Switzerland',
          'SE': 'Sweden',
          'NO': 'Norway',
          'DK': 'Denmark',
          'FI': 'Finland',
          'PL': 'Poland',
          'CZ': 'Czech Republic',
          'IE': 'Ireland',
          'PT': 'Portugal',
          'GR': 'Greece',
          'JP': 'Japan',
          'KR': 'South Korea',
          'CN': 'China',
          'IN': 'India',
          'BR': 'Brazil',
          'MX': 'Mexico',
          'AR': 'Argentina',
          'NZ': 'New Zealand',
          'SG': 'Singapore',
          'MY': 'Malaysia',
          'TH': 'Thailand',
          'VN': 'Vietnam',
          'PH': 'Philippines',
          'ID': 'Indonesia'
        };
        return countries[code] || code;
      }
  
      formatDate(date, format) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                       'July', 'August', 'September', 'October', 'November', 'December'];
        const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        
        let formatted = format;
        
        formatted = formatted.replace(/MMMM/g, months[month]);
        formatted = formatted.replace(/MMM/g, shortMonths[month]);
        formatted = formatted.replace(/MM/g, String(month + 1).padStart(2, '0'));
        formatted = formatted.replace(/M/g, String(month + 1));
        formatted = formatted.replace(/dd/g, String(day).padStart(2, '0'));
        formatted = formatted.replace(/d/g, String(day));
        formatted = formatted.replace(/yyyy/g, String(year));
        formatted = formatted.replace(/yy/g, String(year).slice(-2));
        
        return formatted;
      }
    }
  
    document.addEventListener('DOMContentLoaded', () => {
      const timelines = document.querySelectorAll('.shipping-box[data-block-id]');
      timelines.forEach(timeline => {
        new DeliveryTimeline(timeline);
      });
    });
  
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        const timelines = document.querySelectorAll('.shipping-box[data-block-id]');
        timelines.forEach(timeline => {
          if (!timeline.dataset.initialized) {
            timeline.dataset.initialized = 'true';
            new DeliveryTimeline(timeline);
          }
        });
      });
    }
  })();
  